import { DownOutlined, PlusOutlined, WarningOutlined } from "@ant-design/icons";
import React from "react";
import { clickEvents } from "../../../../services/mixpanel";
import { quoteAddItem, setRequiredInfoMissing } from "../../redux/QuoteActions";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { getRequiredFieldsByCategory } from "../../tools/helpers";
import { ButtonContainer, StyledDropdownButton } from "./DropdownButton.styles";
import { Button, notification } from "antd";
import { isTravesiaCatedral } from "../../../../helpers/rentals";
import { uniqueId } from "lodash";

const DropdownButton = ({
  closeModal,
  trackEvent,
  productId,
  title,
  category,
  supplierData,
  passengersMenu,
  passengerId,
  arrayCategories,
  activePassenger,
  viewButtonAddPassenger,
}) => {
  const rowId = uniqueId(Date.now());
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleClick = (passId = passengerId) => {
    closeModal();
    if (isTravesiaCatedral(supplierData._id) && viewButtonAddPassenger) {
      notification.open({
        message: <b>{t("shop:notification.wantToBookOrQuote")}</b>,
        description: <>{t("shop:notification.scrollDownToQuoter")}</>,
        duration: 10,
        top: 80,
        icon: <WarningOutlined style={{ color: "#FFCC33" }} />,
      });
    }
    trackEvent(clickEvents.ADD_BUNDLE_TO_BASKET, {
      page: "Quote",
      itemId: productId,
      itemTitle: title,
      category: category,
      supplierId: supplierData._id,
      supplierName: supplierData.name,
    });
    dispatch(quoteAddItem(productId, passId, rowId));
    const requiresExtraInfo = getRequiredFieldsByCategory(
      arrayCategories,
      supplierData._id
    );
    if (requiresExtraInfo) {
      dispatch(setRequiredInfoMissing(requiresExtraInfo, passId, rowId));
    }
  };

  if (viewButtonAddPassenger) {
    const menuItems = {
      items: passengersMenu?.items,
      onClick: ({ key }) => handleClick(key),
    };

    return (
      <ButtonContainer>
        <StyledDropdownButton
          icon={<DownOutlined />}
          type="primary"
          onClick={() => handleClick()}
          menu={menuItems}
          placement="bottomRight"
        >
          {t("shop:addToPassenger", {
            name: activePassenger?.name || t("shop:unnamedPassenger"),
          })}
        </StyledDropdownButton>
      </ButtonContainer>
    );
  }

  return (
    <Button
      type="primary"
      style={{ alignSelf: "end", justifySelf: "end" }}
      icon={<PlusOutlined />}
      onClick={() => handleClick()}
    >
      {t("shop:addButton")}
    </Button>
  );
};

export default DropdownButton;
